import { ArquivoUpload } from "./arquivo-upload";

export class AlteracoesArquivoUpload{
    arquivosParaUpload: ArquivoUpload[];
    arquivosParaExcluir: ArquivoUpload[];
}